/* eslint-disable camelcase */

// AH-TEMPLATE locale
export enum LocaleLegacy {
    nl_NL = 'nl_NL',
    nl_BE = 'nl_BE',
}

//  AH-VENTURE locale
export enum Locale {
    nl_NL = 'nl-NL',
    nl_BE = 'nl-BE',
    en_US = 'en-US',
}

export type SupportedLocale = `${Locale}` | `${LocaleLegacy}`;
